$(function(){

  var $body = $('body');
  var scrollTop;

  //スクロールを固定
  function bodyFixedOn() {
    scrollTop = $(window).scrollTop();

    $body.css({
      position: 'fixed',
      top: -scrollTop,
      'overflow-y': 'hidden'
    });
  }

  //スクロールの固定を解除
  function bodyFixedOff() {
    $body.css({
      position: '',
      top: '',
      'overflow-y': ''
    });
      
    $(window).scrollTop(scrollTop);
  }

  // 変数
  var ac_open = $('#ac-open');
  var ac_menu = $('#ac-menu');
  var ac_close = $('#ac-close');

  // ハンバーガーメニュー　変数
  ac_open.click(function(){
    $(this).toggleClass('open');

    if (ac_open.hasClass('open')) {
      bodyFixedOn();
      ac_menu.addClass('active');
    } else {
      bodyFixedOff();
      ac_menu.removeClass('active');
    }
  });
  ac_close.click(function(){
    bodyFixedOff();
    ac_open.removeClass('open');
    ac_menu.removeClass('active');
  });

  const header = $('header').outerHeight();
  const scroll = 500;

  // スムーススクロール
  $('a[href^="#"]').click(function(){
    const href= $(this).attr("href"),
    target = $(href == "#" || href == "" ? 'html' : href),
    position = target.offset().top - header -100;
    $("html, body").animate({scrollTop:position}, scroll, "swing");  
  });

  // 別ページからのスクロール
  $(window).on('load', function() {
    const url = $(location).attr('href');
  
    if(url.indexOf("#") != -1){
      const anchor = url.split("#"),
      target = $('#' + anchor[anchor.length - 1]),
      position = Math.floor(target.offset().top) - header - 100;
      $("html, body").animate({scrollTop:position}, scroll, "swing");
    }
  });

  // pagetop
  var pagetop = $('#pagetop');

  pagetop.click(function () {
    $('body, html').animate({
      scrollTop: 0
    }, 500);
    return false;
  });

// スライダー
var slider_option03 = {};
var slider_option04 = {};
var slider_option05 = {};

slider_option03 = {
  slidesPerView: 1.3,
  spaceBetween: 30,
  breakpoints: {
    767: {
      slidesPerView: 3,  
    }
  },
  navigation: {
    nextEl: '.product-button-next',
    prevEl: '.product-button-prev',
  }
}
slider_option04 = {
  slidesPerView: 1.9,
  spaceBetween: 30,
  breakpoints: {
    767: {
      slidesPerView: 4,  
      spaceBetween: 25,
    }
  },
  navigation: {
    nextEl: '.product-button-next',
    prevEl: '.product-button-prev',
  }
}
slider_option05 = {
  slidesPerView: 3.5,
  spaceBetween: 15,
  breakpoints: {
    767: {
      slidesPerView: 5,  
      spaceBetween: 25,
    }
  },
  navigation: {
    nextEl: '.product-button-next',
    prevEl: '.product-button-prev',
  }
}

// 3個
new Swiper('.three-swiper', slider_option03);
// 4個
new Swiper('.four-swiper', slider_option04);
// 5個
new Swiper('.five-swiper', slider_option05);

});